//noScroll
class Facility {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let carousel = new Swiper('.js-carousel', {
      autoplay: {
        delay: 2500, // 2500ミリ秒 = 2.5秒後に次のスライドへ
        disableOnInteraction: false, // ユーザーの操作後も自動再生を継続
      },
      slidesPerView: 1.3,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      speed: 500,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        //767px以上の場合
        767: {
          slidesPerView: 2.7,
        }
      }
    });

    var voiceSwiper = new Swiper('.voiceSwiper', {
      slidesPerView: 1.2,
      spaceBetween: 8,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        //767px以上の場合
        767: {
          slidesPerView: 2.5,
          spaceBetween: 16,
        }
      }
    });

    const heading = document.querySelector('.js-header');

    // オプション指定
    const options = {
      threshold: 0 // 指定範囲は0 〜 1
    };

    // 実行
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.intersectionRatio == 0) {
          $('.facility-header__hum').addClass('is-scroll');
        } else {
          $('.facility-header__hum').removeClass('is-scroll');
        }
      });
    }, options);

    observer.observe(heading);

    const mediaQuery = window.matchMedia('(min-width: 768px)')
    if (mediaQuery.matches) {
      gsap.to('.s-point', { // 動かしたい要素
        scrollTrigger: {
          trigger: '.s-point', // 要素がビューポートに入ったときにアニメーション開始
          start: 'center center', // アニメーション開始位置
          end: 'center center-=2400px', // アニメーション終了位置
          scrub: 1,
          pin: true,
          onUpdate: function(self) {
            if(600 > parseInt(window.pageYOffset - self.start)) {
              $('.s-point__card').eq(1).removeClass('is-active');
            } else if(600 < parseInt(window.pageYOffset - self.start) && 1200 > parseInt(window.pageYOffset - self.start)) {
              $('.s-point__card').eq(1).addClass('is-active');
              $('.s-point__card').eq(2).removeClass('is-active');
            } else if(1200 < parseInt(window.pageYOffset - self.start) && 1800 > parseInt(window.pageYOffset - self.start)) {
              $('.s-point__card').eq(2).addClass('is-active');
              $('.s-point__card').eq(3).removeClass('is-active');
            } else if(1800 < parseInt(window.pageYOffset - self.start)) {
              $('.s-point__card').eq(1).addClass('is-active');
              $('.s-point__card').eq(2).addClass('is-active');
              $('.s-point__card').eq(3).addClass('is-active');
            }
          }
        }
      });
    }
  }
}
